import React, { Component } from "react";
import { BaseComponent, LABEL_POSITION_TOP } from "BaseComponent";
import { connect } from "react-redux";
import {
  Field,
  reduxForm,
  reset,
  submit,
  startSubmit,
  stopSubmit,
} from "redux-form";
import _ from "lodash";
import {
  communityModal,
  editCommunity,
  saveCommunity,
  fetchRequestedUsers, // Requested Users list
} from "ActionsCommunity";
import {
  fetchUsersCategory,
  sortUserByCategoryExceptAdmin,
  fetchAllusersforCommunity,
} from "DashboardUserAction";
import { openPrivateSessionUserModal } from "ContentActions";
import SessionPrivateUserModal from "../schedules/session-private-user-modal";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import {
  BASE_IMAGES_URL,
  COMMON_FAIL_MESSAGE,
  maxLengthObjectFc,
} from "Constants";
import IconPicker from "IconPicker";
import IconCropper from "IconCropper";
import { showError, showSuccess } from "ReduxErrorBar";
import { isEmpty } from "BaseFunctions";
import BetaFeature from "BetaFeature";
import LocaleStrings from "Languages";
var MAXLENOBJ = {};
var BTNLOADER = false;
var globalSelectedUsers = [];
class AddCommunity extends Component {
  constructor(props) {
    super(props);
    this.close = this.close.bind(this);
    this.state = { active: false };
    this.formRef = React.createRef();
  }

  componentDidMount() {
    this.props.fetchAllusersforCommunity(this.props.session, (response) => {});

    MAXLENOBJ = maxLengthObjectFc(this.props.history);

    // Should Be at the time of edit
    // Fetching user categories and all admin users first time
    this.props.fetchUsersCategory(this.props.session, (response) => {
      let data = _.filter(response.data, function (o) {
        return o.groupname !== "Admin";
      });

      var attendee = _.filter(data, (obj) => {
        return obj.type === "attendee";
      });

      this.props.sortUserByCategoryExceptAdmin(
        this.props.session,
        attendee[0].id,
        1,
        0,
        (callback) => {}
      );
    });

    /* Fetch users from communitiy member table with status 'requested' [Requested Users list] */
    this.props.fetchRequestedUsers(this.props.session, (response) => {});
  }

  componentWillUnmount() {
    globalSelectedUsers = [];
    this.setState({ active: false });
    this.props.editCommunity({});
    BTNLOADER = false;
  }

  close() {
    this.props.reset();
    this.setState({ active: false });
    this.props.communityModal({ showModal: false });
    this.props.editCommunity({});
  }

  submitFormOn = (e) => {
    this.props.dispatch(startSubmit("AddCommunityForm"));

    this.formRef.current.saveImage(() => {
      this.props.dispatch(submit("AddCommunityForm"));
    });
  };

  render() {
    var {
      handleSubmit,
      pristine,
      dirty,
      reset,
      submitting,
      valid,
      invalid,
      submit,
      addCommunityModal,
      toEdit,
      initialValues,
    } = this.props;

    // var disabled = !(
    //   (dirty && valid) ||
    //   (toEdit && pristine && this.state.active)
    // );
    // if (toEdit && !dirty && valid && pristine) {
    //   disabled = false;
    // }

    var disabled = pristine || invalid || submitting;
    if (toEdit) {
      let len =
        typeof globalSelectedUsers == "object"
          ? Object.keys(globalSelectedUsers).length
          : globalSelectedUsers.length;
      if (len > 0) {
        disabled = false;
      }
    }

    return (
      <Modal
        className="modal-container"
        show={
          addCommunityModal && addCommunityModal.showModal === true
            ? true
            : false
        }
        onHide={this.close}
        animation={true}
        keyboard={false}
        backdrop="static"
        enforceFocus={false}
        dialogClassName={"communityModal"}
      >
        <form onSubmit={handleSubmit(submit)} encType="multipart/form-data">
          <Modal.Header>
            <div className="import-modal-title">
              {toEdit
                ? LocaleStrings.content_community_form_title_edit
                : LocaleStrings.content_community_form_title_add}
            </div>
            <button
              type="button"
              className="i-custom-cross-popup pull-right"
              onClick={() => this.close()}
            >
              <img
                className="i-custom-small"
                src="../../style/images/custom-icons/cross-black.png"
              />
            </button>
          </Modal.Header>
          <Modal.Body>
            <BasicForm
              {...this.props}
              communityitem={this.props.initialValues}
              session={this.props.session}
              onImageChange={(img) => this.setState({ active: true })}
              ref={this.formRef}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button
              bsStyle=""
              className="btn btn-custom-white"
              onClick={this.close}
            >
              {LocaleStrings.button_close}
            </Button>
            <Button
              className="btn btn-custom-blue ml-10"
              bsStyle=""
              type="button"
              loading={BTNLOADER}
              onClick={this.submitFormOn}
              disabled={disabled}
            >
              {LocaleStrings.button_save}
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }
}

function validate(values, state) {
  var errors = {};
  var requiredFields = ["categoryicon", "categoryname", "type"];
  var description = values["description"];

  requiredFields.forEach((field) => {
    if (!values[field]) {
      errors[field] = "Required";
    }
    if (field == "categoryname") {
      if (values[field] && values[field].trim() === "") {
        errors[field] = "Required";
      }
    }
  });

  // if (description && description.trim().length > 40) {
  //   errors["description"] = "Max length 40";
  // }

  if (values["categoryname"] && MAXLENOBJ) {
    if (values["categoryname"].length > MAXLENOBJ.categoryname) {
      errors["categoryname"] =
        LocaleStrings.max_characters_left + MAXLENOBJ.categoryname;
    }
  }

  if (values["description"] && MAXLENOBJ) {
    if (values["description"].length > MAXLENOBJ.description) {
      errors["description"] =
        LocaleStrings.max_characters_left + MAXLENOBJ.description;
    }
  }

  return errors;
}

function mapStateToProps(state) {
  var toEdit = !isEmpty(state.editCommunity);
  var initVals = { isprivate: "0" };

  if (toEdit) {
    var appUsers = state.dashboardUserList.data; // New
    let allAppUsers = state.totalUsers.data;

    initVals = state.editCommunity;

    initVals.isprivate = state.editCommunity.isprivate == 1 ? "1" : "0";

    var selectedAppusers = [];

    // Sorting selected appuser details; // old code var selectedusers = _.filter(appUsers, (obj) => {
    _.map(initVals.communitymember_by_communitycategoryidfk, (item) => {
      var selectedusers = _.filter(allAppUsers, (obj) => {
        //return obj.appuserid === item.useridfk && item.status === "accepted";
        return obj.appuserid === item.useridfk;
      });

      if (selectedusers) {
        if (selectedusers.length > 0) {
          var user = {
            ...selectedusers[0],
            checked: true,
            status: item.status,
          };
          selectedAppusers.push(user);
        }
      }
    });

    initVals = {
      ...initVals,
      selectedAppusers: selectedAppusers,
    };
  }

  return {
    session: state.session,
    addCommunityModal: state.addCommunityModal,
    toEdit,
    initialValues: initVals,
    sessionPrivateUsersModal: state.sessionPrivateUsersModal,
    userList: state.dashboardUserList,
    allUserList: state.totalUsers,
  };
}

function onFormSubmit(values, dispatch, props) {
  BTNLOADER = true;
  values.categoryname = values.categoryname.trim();
  var data = { ...values };
  var communityitem = props.initialValues;

  /* Validation For Private [Dont delte this code] */
  // if (!communityitem.communitycategoryid) {
  //   if (
  //     values.isprivate == 1 &&
  //     (typeof globalSelectedUsers == "object"
  //       ? Object.keys(globalSelectedUsers).length
  //       : globalSelectedUsers.length) == 0
  //   ) {
  //     props.showError(
  //       LocaleStrings.content_community_validation_for_atleast_one_selection
  //     );
  //     props.stopSubmit("AddCommunityForm");
  //   }
  // }

  // We are storing icon json data to use in app and web with required key
  if (typeof data.categoryicon === "object") {
    data.categoryicon = JSON.stringify(data.categoryicon);
  }

  /*** To add as accepted ***/
  if (communityitem.communitycategoryid && parseInt(values.isprivate) === 1) {
    _.forEach(globalSelectedUsers, (item, index) => {
      // If New User Come
      if (
        _.findIndex(
          data.communitymember_by_communitycategoryidfk,
          function (o) {
            return o.useridfk == item.appuserid;
          }
        ) === -1
      ) {
        // New User

        let obj = {
          eventid: parseInt(props.session.eventid),
          status: "accepted",
          useridfk: item.appuserid,
        };

        // push the new User Object
        data.communitymember_by_communitycategoryidfk.push(obj);
      } else {
        // For Old Users
        _.forEach(
          data.communitymember_by_communitycategoryidfk,
          (itemx, index) => {
            if (item.appuserid === itemx.useridfk) {
              // itemx.status = "accepted";
              itemx.status = item.status;
            }
          }
        );
      }
    });
  }

  /*** If not [Make rejected] ***/
  if (communityitem.communitycategoryid && parseInt(values.isprivate) === 1) {
    _.forEach(data.communitymember_by_communitycategoryidfk, (item, index) => {
      if (
        _.isEmpty(_.filter(globalSelectedUsers, { appuserid: item.useridfk }))
      ) {
        item.status = item.status;
      }
    });
  }

  return new Promise((resolve, reject) => {
    return props.saveCommunity(
      props.session,
      data,
      communityitem,
      globalSelectedUsers,
      (result) => {
        props.stopSubmit("AddCommunityForm");
        if (result.error === 1) {
          props.showError(COMMON_FAIL_MESSAGE);
          return reject(result.error);
        } else if (result.error === 2) {
          props.showError(
            LocaleStrings.content_community_form_save_image_error
          );
          return reject(result.error);
        } else {
          props.showSuccess(LocaleStrings.content_community_form_save_success);
          props.communityModal({ showModal: false });
          props.editCommunity({}); // Initilizing thi sobject as blank other ways it will show edit data in add
          props.reset();
          props.finishOperationsCallback();

          return resolve(result);
        }
        BTNLOADER = false;
      }
    );
  });
}

export default connect(mapStateToProps, {
  showError,
  showSuccess,
  communityModal,
  editCommunity,
  saveCommunity,
  fetchUsersCategory,
  sortUserByCategoryExceptAdmin,
  openPrivateSessionUserModal,
  fetchRequestedUsers, // Requested Users list
  fetchAllusersforCommunity, // to backup support for community
})(
  reduxForm({
    validate,
    form: "AddCommunityForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
    onSubmit: onFormSubmit,
  })(AddCommunity)
);

class BasicForm extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      imagePreviewUrl: "",
      showORhideUsers: "hide", // To Show Hide "View/participate users"
      loadingPrivateUser: false, // "View/participate users" button
      selectedMembers: [], // "View/participate users"
      selectedMembersUpdate: false, // "View/participate users"
      icon: "",
      iconScreen: "",
    };

    /*  if (props.communityitem && props.communityitem.categoryicon) {
      this.state = {
        imagePreviewUrl: `${BASE_IMAGES_URL}/${props.communityitem.categoryicon}?api_key=${props.session.apiKey}&session_token=${props.session.sessionToken}`,
        showORhideUsers:
          props.communityitem.isprivate === 1 ||
          props.communityitem.isprivate === "1"
            ? "show"
            : "hide",
      };
    } */
    this.onImageSave = this.onImageSave.bind(this);
    this.cropperRef = React.createRef();
    this.handelCommunityType = this.handelCommunityType.bind(this);
    this.onIconChange = this.onIconChange.bind(this);
  }

  componentDidMount() {
    MAXLENOBJ = maxLengthObjectFc(this.props.history); // filter This form name object With route
    var { session, communityitem, toEdit } = this.props;
    if (toEdit && communityitem.categoryicon) {
      let itsImage = false;
      if (
        communityitem.categoryicon.endsWith(".jpg") ||
        communityitem.categoryicon.endsWith(".png")
      ) {
        itsImage = true;
      }

      if (itsImage) {
        this.setState({
          imagePreviewUrl: `${BASE_IMAGES_URL}/${communityitem.categoryicon}?api_key=${session.apiKey}&session_token=${session.sessionToken}`,
          iconScreen: "iconFromImage",
        });
      } else {
        this.setState({
          icon: JSON.parse(communityitem.categoryicon),
          iconScreen: "iconFromLibrary",
        });
      }
    }
    this.setState({
      showORhideUsers:
        communityitem.isprivate === 1 || communityitem.isprivate === "1"
          ? "show"
          : "hide",
    });
  }

  onImageSave = (img) => {
    this.props.autofill("categoryicon", img);
    this.setState({
      imagePreviewUrl: img === "" ? "" : img,
      ...(img === "" ? {} : { iconScreen: "iconFromImage" }),
    });
  };

  onIconChange = (selectedIcon) => {
    this.props.autofill("categoryicon", selectedIcon);
    this.setState({ icon: selectedIcon, iconScreen: "iconFromLibrary" });
  };

  resetIcon = () => {
    this.props.autofill("categoryicon", "");
    this.setState({ icon: "", iconScreen: "" });
  };

  saveImage = (callback) => {
    if (this.state.imageAvailable) {
      this.cropperRef.current.saveImage(callback);
    } else {
      callback();
    }
  };

  onImageChange = (imageAvailable) => {
    if (imageAvailable !== undefined) this.setState({ imageAvailable });
  };

  /* Cummunity Type On Change Handel */
  handelCommunityType = (e) => {
    this.setState((state, props) => ({
      showORhideUsers:
        e.target.value === 1 || e.target.value === "1" ? "show" : "hide",
    }));
  };

  handleAccoicatedUsers = (newusers) => {
    if (newusers.length > 0) {
      globalSelectedUsers = { ...newusers };
    }

    this.setState({
      selectedMembers: newusers,
      selectedMembersUpdate: true,
    });
  };

  openPrivateUserModal = () => {
    this.setState({ loadingPrivateUser: true });

    // Fetching user categories and all admin users first time
    this.props.fetchUsersCategory(this.props.session, (response) => {
      var admins = _.filter(response.data, (obj) => {
        return obj.type === "attendee";
      });

      this.props.sortUserByCategoryExceptAdmin(
        this.props.session,
        admins[0].id,
        1,
        0,
        (callback) => {
          this.props.openPrivateSessionUserModal({ show: true });
          this.setState({ loadingPrivateUser: false });
        }
      );
    });
  };

  render() {
    let {
      imagePreviewUrl,
      showORhideUsers,
      selectedMembersUpdate,
      selectedMembers,
      icon,
      iconScreen,
    } = this.state;
    let { toEdit, initialValues, userList } = this.props;
    var allSelectedUsers = [];
    let options = [
      {
        name: LocaleStrings.content_community_form_label_type_option1,
        value: "post",
      },
      {
        name: LocaleStrings.content_community_form_label_type_option2,
        value: "group",
      },
    ];

    if (toEdit) {
      allSelectedUsers = initialValues.selectedAppusers;
    }

    if (selectedMembersUpdate) {
      allSelectedUsers = selectedMembers;
    } else {
      if (initialValues.selectedAppusers) {
        allSelectedUsers = initialValues.selectedAppusers;
      } else {
        // Bydefault Selected One Add the Time of add
        if (!toEdit) {
          if (userList && userList.data && userList.data.length > 0) {
            var user = { ...userList.data[0], checked: true };
            allSelectedUsers.push(user);
          }
        }
      }
    }

    return (
      <div>
        <div className="basicform">
          <div className="row form-group">
            <div className="col-sm-4">
              <label className="control-label-top">
                {LocaleStrings.content_community_form_label_icon}
                <span className="label-mandatory">*</span>
                <span className="ps-1">
                  <BetaFeature />
                </span>
              </label>
              <div className="eventguide-icon-bg p-2">
                {iconScreen === "" ||
                (iconScreen === "iconFromImage" &&
                  iconScreen != "iconFromLibrary") ? (
                  <IconCropper
                    displaySize={{ width: 150, height: 150 }} // For image display style
                    requiredSize={{ width: 84, height: 84 }} // For image size required validation
                    cropperSize={{ width: 100, height: 100 }} // Cropper display size. Note its add 50px for padding
                    border={10}
                    onImageSave={this.onImageSave}
                    onImageChange={this.onImageChange}
                    imagepath={imagePreviewUrl}
                    imageType="jpg"
                    className="drop-zone-area-custom-image"
                    insideImage="../../style/images/dummy-image-fill@3x.png"
                    insideImageStyle={{
                      width: 54,
                      height: 54,
                    }}
                    ref={this.cropperRef}
                    insideText={
                      LocaleStrings.content_community_form_label_icon_size_text
                    }
                  />
                ) : (
                  ""
                )}
                {icon != "" ? (
                  <div
                    className="custom-align-center"
                    style={{ width: 150, height: 150 }}
                  >
                    <div className="communnity-iconpicker-remove-button-position">
                      <Button
                        type="button"
                        className={`btn-custom-default-sm`}
                        onClick={this.resetIcon}
                      >
                        {LocaleStrings.button_remove}
                      </Button>
                    </div>
                    <i className={icon.title} style={{ fontSize: 120 }}></i>
                  </div>
                ) : (
                  ""
                )}
                <Field
                  name="categoryicon"
                  type="text"
                  component={this.renderHiddenFieldText}
                />
                {(imagePreviewUrl === "") & (icon === "") ? (
                  <div className="mt-5 ">
                    <IconPicker value={icon} onChange={this.onIconChange} />
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
          <Field
            name="categoryname"
            label={LocaleStrings.content_community_form_label_name}
            placeholder={LocaleStrings.content_community_form_ph_name}
            type="text"
            component={this.renderFieldText}
            mandatory="true"
            labelposition={LABEL_POSITION_TOP}
            maxlength={MAXLENOBJ.categoryname ? MAXLENOBJ.categoryname : ""}
          />
          <Field
            name="description"
            label={LocaleStrings.content_community_form_label_desc}
            placeholder={LocaleStrings.content_community_form_ph_desc}
            component={this.renderFieldTextarea}
            mandatory="false"
            labelposition={LABEL_POSITION_TOP}
            maxlength={MAXLENOBJ.description ? MAXLENOBJ.description : ""}
          />
          <Field
            name="type"
            label={LocaleStrings.content_community_form_label_type}
            placeholder={LocaleStrings.content_community_form_ph_type}
            mandatory="true"
            component={this.renderSelect}
            opts={options}
            labelposition={LABEL_POSITION_TOP}
          />
          <Field
            name="postadminonly"
            label={LocaleStrings.content_community_form_label_post_permission}
            type="checkbox"
            component={this.renderFieldCheckbox}
          />
          <div className="form-group row">
            <label className="control-label-top col-sm-12">
              {LocaleStrings.content_community_form_label_category}
            </label>
            <div className="col-md-12 d-flex">
              <Field
                name="isprivate"
                label={LocaleStrings.content_community_form_category_option1}
                component={this.renderFieldRadio}
                type="radio"
                value="0"
                onChange={this.handelCommunityType}
              />
              <Field
                name="isprivate"
                label={LocaleStrings.content_community_form_category_option2}
                component={this.renderFieldRadio}
                type="radio"
                value="1"
                onChange={this.handelCommunityType}
              />
            </div>
          </div>
          {showORhideUsers === "show" ? (
            <Button
              bsStyle=""
              className="btn btn-custom-blue"
              onClick={this.openPrivateUserModal}
              loading={this.state.loadingPrivateUser}
            >
              <i className="fa fa-plus i-custom-m" aria-hidden="true" />
              {LocaleStrings.button_view_manage_users}
            </Button>
          ) : (
            ""
          )}
        </div>
        {this.props.sessionPrivateUsersModal.show ? (
          <SessionPrivateUserModal
            initialValues={this.props.initialValues}
            updateAccoicatedUsers={this.handleAccoicatedUsers}
            membersData={allSelectedUsers}
            flag="COMMUNITY"
          />
        ) : null}
      </div>
    );
  }
}
